import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import Router from './services/router';
import Store from './services/store/store';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueMeta from 'vue-meta';
import 'swiper/css/swiper.css';
import 'swiper/css/swiper.min.css';
Vue.use(ElementUI);
Vue.use(VueMeta);
Vue.config.productionTip = false;
// Vue.config.errorHandler = function(err, vm, info) {
//   console.log(`Error: ${err.toString()}\nInfo: ${info}`);
// }
// Vue.config.warnHandler = function(msg, vm, trace) {
//   console.log(`Warn: ${msg}\nTrace: ${trace}`);
// }
new Vue({
    template: '<App/>',
    router: Router,
    store: Store,
    render: function (h) {
        return h(App);
    }
}).$mount('#app');
